import type {ComponentExportStructure} from '@wix/document-services-types'
import type {DecorationSingleComponentPluginFunction} from '../../types'

// This pluging generates types like Button, Text, etc. If there are repeated types, it will generate unique types like Button1, Button2, etc.
export const pack: DecorationSingleComponentPluginFunction = (
    component: ComponentExportStructure,
    {nicknameGenerator}
) => {
    component.type = nicknameGenerator.generateNickname(`type-${component.id}`, {
        prefix: component.displayName ?? component.type ?? component.componentType ?? 'W',
        getNicknameKey: ({prefix, counter}) => `${prefix}${counter === 1 ? '' : counter}`
    })
    delete component.componentType
}
